<app-labels [labels]="widgetLayers.layer(current).chartTitle" [color]="color" [label]="'TITLE_LABEL'" (sendLabel)="receiveLabel($event)"></app-labels>